import { SelectionPart, SelectionTab } from '../../hooks/useGetOrderDetail';

const AUTO_EXCLUDED_DUPLICATE_REASON = 'Auto-excluded duplicate part';

const TAB_ORDER: Array<SelectionTab['key']> = ['pending', 'no-quoted', 'excluded', 'ordered', 'all'];

const isAutoExcludedDuplicatePart = (part: Pick<SelectionPart, 'flagReason'>): boolean =>
    part.flagReason === AUTO_EXCLUDED_DUPLICATE_REASON;

export const relocateAutoExcludedDuplicates = (tabs: Array<SelectionTab>): Array<SelectionTab> => {
    const noQuoted = tabs.find((tab) => tab.key === 'no-quoted');
    if (!noQuoted) return tabs;

    const duplicates = noQuoted.parts.filter(isAutoExcludedDuplicatePart);
    if (duplicates.length === 0) return tabs;

    const remaining = noQuoted.parts.filter((part) => !isAutoExcludedDuplicatePart(part));
    const next = tabs.filter((tab) => tab.key !== 'no-quoted');
    if (remaining.length > 0) {
        next.push({ ...noQuoted, parts: remaining, total: remaining.length });
    }

    const excluded = next.find((tab) => tab.key === 'excluded');
    if (excluded) {
        const existingIds = new Set(excluded.parts.map((part) => part.partId));
        const toAdd = duplicates.filter((part) => !existingIds.has(part.partId));
        const excludedIndex = next.indexOf(excluded);
        next[excludedIndex] = {
            ...excluded,
            parts: [...excluded.parts, ...toAdd],
            total: excluded.parts.length + toAdd.length,
        };
    } else {
        next.push({
            key: 'excluded',
            title: 'Excluded',
            parts: duplicates,
            total: duplicates.length,
        });
    }

    return next.sort((a, b) => TAB_ORDER.indexOf(a.key) - TAB_ORDER.indexOf(b.key));
};
